import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { ManagementTierSetupService } from 'src/app/service/management/tier-setup.service';

@Component({
  selector: 'app-add-tier-dialog',
  templateUrl: './add-tier-dialog.component.html',
  styleUrls: ['./add-tier-dialog.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class AddTierDialogComponent implements OnInit {
  heading: string;
  eventType: string;
  tierId: number;
  tierName;
  tlmsRouteTypeCode;
  masterTable;
  dependency;
  lockTrigger;
  otherTierData;
  enableError = false;
  errormsg: string;
  periodId;
  tlmsRouteTypeCodeData = []
  selectedTlmsRouteTypeCode;
  selectedTlmsRouteTypeCodeArrayObject = [];
  masterTableData = []
  selectedMasterTable;
  selectedMasterTableObject;
  dependencyData = []
  selectedDependency;
  selectedDependencyObject;
  lockTriggerData = []
  selectedLockTrigger;
  selectedLockTriggerObject;
  includeOtherTierData = []
  selectedIncludeOtherTier;
  selectedIncludeOtherTierArrayObject = [];
  tierPosition;

  constructor(public dialogRef: MatDialogRef<AddTierDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly tiersetupService: ManagementTierSetupService) {

  }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType

    this.tlmsRouteTypeCodeData = this.dataStore.tlmsRouteTypeCodeData
    this.masterTableData = this.dataStore.masterTableData
    this.dependencyData = this.dataStore.dependencyData
    this.lockTriggerData = this.dataStore.lockTriggerData
    this.includeOtherTierData = this.dataStore.includeOtherTierData
    this.periodId = this.dataStore.periodId;
    if (this.eventType == 'EDIT') {  // NOSONAR

      this.tierId = this.dataStore.tierId
      this.tierName = this.dataStore.tierName
      this.tlmsRouteTypeCode = this.dataStore.tlmsRouteTypeCode
      this.masterTable = this.dataStore.masterTable
      this.dependency = this.dataStore.dependency
      this.lockTrigger = this.dataStore.lockTrigger
      this.otherTierData = this.dataStore.otherTierData
      this.tierPosition = this.dataStore.tierposition

      const tlmsRouteTypeCodeStringToArray = this.tlmsRouteTypeCode.split(",");
      if (tlmsRouteTypeCodeStringToArray.length > 0)
       { tlmsRouteTypeCodeStringToArray.forEach(element => {
          const tempTlmsRouteTypeCodeArrayObject = this.tlmsRouteTypeCodeData.find(x => x.value == element)  // NOSONAR
          this.selectedTlmsRouteTypeCodeArrayObject.push(tempTlmsRouteTypeCodeArrayObject)
        });}
      this.selectedMasterTableObject = this.masterTableData.find(x => x.value == this.masterTable)  // NOSONAR
      this.selectedDependencyObject = this.dependencyData?.find(x => x.value == this.dependency)   // NOSONAR
      this.selectedLockTriggerObject = this.lockTriggerData?.find(x => x.value == this.lockTrigger)  // NOSONAR
      const otherTierDataStringToArray = this.otherTierData?.split(",");
      if (otherTierDataStringToArray && otherTierDataStringToArray.length > 0)
       { otherTierDataStringToArray.forEach(element => {
          const tempIncludeOtherTierArrayObject = this.includeOtherTierData.find(x => x.value == element)  // NOSONAR
          this.selectedIncludeOtherTierArrayObject.push(tempIncludeOtherTierArrayObject)
        });}

    }
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    this.errormsg = ""

    if (this.isValueOk(this.tierName)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.tierPosition)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selectedTlmsRouteTypeCodeArrayObject)) {
      this.showError(this.constants.formInputError);
    } else if (this.tierPosition == 1) {  // NOSONAR
      if (String(this.tierName).toLowerCase().trim() == "cl unassigned on preceeding")  // NOSONAR
        {this.saveAPICall();}
      else {this.showError("TierPosition: 1 is System Restricted with TierName: CL Unassigned on Preceeding.");}
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.selectedTlmsRouteTypeCodeArrayObject.sort((a, b) => (a.id > b.id ? 1 : -1))
    this.selectedTlmsRouteTypeCode = this.selectedTlmsRouteTypeCodeArrayObject.map(x => Number(x.id)).toString()
    this.selectedIncludeOtherTierArrayObject.sort((a, b) => (a.id > b.id ? 1 : -1))
    this.selectedIncludeOtherTier = this.selectedIncludeOtherTierArrayObject?.map(x => Number(x.id)).toString()
    const result = {
      tierId: this.tierId,
      tierName: this.tierName,
      tierPos: this.tierPosition,
      tlmsRouteTypeCode: this.selectedTlmsRouteTypeCode ? this.selectedTlmsRouteTypeCode : null,
      masterTable: this.selectedMasterTableObject ? this.selectedMasterTableObject.value : null,
      dependency: this.selectedDependencyObject ? this.selectedDependencyObject?.value : null,
      lockTrigger: this.selectedLockTriggerObject ? this.selectedLockTriggerObject?.value : null,
      includeOtherTier: this.selectedIncludeOtherTier ? this.selectedIncludeOtherTier : null,
      masterTableID: this.selectedMasterTableObject ? this.selectedMasterTableObject.id : null,
      dependencyID: this.selectedDependencyObject ? this.selectedDependencyObject.id : null,
      dependencyPos: this.selectedDependencyObject ? this.selectedDependencyObject.position : null,
      lockTriggerID: this.selectedLockTriggerObject ? this.selectedLockTriggerObject.id : null,
      lockTriggerPos: this.selectedLockTriggerObject ? this.selectedLockTriggerObject.position : null,

    }
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    if (this.eventType == "ADD") {  // NOSONAR

      this.tiersetupService.addTier({
        periodId: this.periodId,
        tierName: result.tierName,
        tlmsRouteTypeCode: result.tlmsRouteTypeCode,
        masterTable: result.masterTableID,
        dependency: result.dependencyPos,
        lockTrigger: result.lockTriggerPos,
        otherTierData: result.includeOtherTier,
        tierPos: result.tierPos
      }).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          console.info(response)
          if (response == "Success") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else if (response == this.constants.APIDataAlreadyExists)  // NOSONAR
            {this.showError(response)}
          else {
            this.showError(this.constants.APIErrorMessage);
          }
        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);

        });

    } else if (this.eventType == "EDIT") {  // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.tiersetupService.updateTier(result.tierId, this.periodId, result.tierName, result.tlmsRouteTypeCode, result.masterTableID, result.dependencyPos, result.lockTriggerPos, result.includeOtherTier, result.tierPos).subscribe(
        response => {
          if (response == "Success") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else if (response == this.constants.APIDataAlreadyExists)  // NOSONAR
            {this.showError(response)}
          else {
            this.showError(this.constants.APIErrorMessage);
          }
        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTime);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") {  // NOSONAR
      return true;
    }
    return false;
  }

}
